var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',_vm._b({staticClass:"text-center pa-1",class:{
    'rounded-circle': _vm.currentField.isType == 'CIRCLE',
    'pa-1':
      _vm.currentField.isType == 'CIRCLE' ||
      _vm.currentField.isType == 'ROUND_SQUARE',
    rounded: _vm.currentField.isType == 'ROUND_SQUARE',
  }},'h4',_vm.attributesBinding,false),[_vm._v(" "+_vm._s(_vm.currentField.value.ja ? _vm.currentField.value.ja : _vm.currentField.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }